import { useAccountStore } from '@/store/use-account-store';
import { useMarketStore } from '@/store/use-markets-store';
import { useOrdersStore } from '@/store/use-orders-store';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

type Props = {
  orderId: string;
};

export default function MidPrice({ orderId }: Props) {
  const address = useAccountStore((state) => state.address);
  const symbol = useOrdersStore(
    (state) => state.getOrders(address).orders[orderId].symbol,
  );
  const { midPrice, priceDecimals } = useStore(
    useMarketStore(symbol),
    useShallow((state) => ({
      midPrice: state.marketData.midPrice,
      priceDecimals: state.marketSpec.priceDecimals,
    })),
  );

  return formatBigInt(midPrice, priceDecimals, {
    digits: Number(priceDecimals),
    style: 'currency',
  });
}

export const midPriceAccessorFn = (id: string) => {
  const { address } = useAccountStore.getState();
  const { orders } = useOrdersStore.getState().getOrders(address);
  const { marketData, marketSpec } = useMarketStore(
    orders[id].symbol,
  ).getState();
  return bigIntToNum(marketData.midPrice, marketSpec.priceDecimals);
};
